import styled from "styled-components";

export const Container = styled.div`
  margin-top: 1rem;
  display: flex;
  align-items: baseline;
  .label {
    margin-bottom: 0px;
    color: #626262;
    font-family: Linotte;
    font-size: 16px;
    margin-top: 0.5rem;
    margin-right: 0.4rem;
  }
  .answer-wrapper {
    display: flex;
    flex-wrap: wrap;
  }
`;
